import { Text } from "@fluentui/react/lib/Text";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { getTheme } from "@fluentui/react";
import customTheme from "helpers/customTheme";
import icons from "components/shared/Icons";
import usePolicyEditPanelManager from "hooks/policy/usePolicyEditPanelManager";
import { PolicyEditPanelType } from "store/policyEditPanelManagementSlice";

const emptyStructureClass = mergeStyleSets({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 200px)",
    padding: "40px 20px",
    textAlign: "center",
  },
  icon: {
    fontSize: "48px",
    color: customTheme.bodySubText,
    marginBottom: "20px",
  },
  title: {
    marginBottom: "12px",
    color: customTheme.bodyColor,
    fontWeight: "bold",
  },
  description: {
    maxWidth: "400px",
    lineHeight: "1.5",
    color: customTheme.bodySubText,
  },
  link: {
    color: getTheme().palette.themePrimary,
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: getTheme().palette.themeDark,
    },
  },
});

function PolicyEditEmptyStructure() {
  const { openPanel } = usePolicyEditPanelManager();

  const handleAddTemplateClick = () => {
    openPanel(PolicyEditPanelType.AddTemplate);
  };

  return (
    <div className={emptyStructureClass.container}>
      <div className={emptyStructureClass.icon}>
        {icons.pageEdit?.iconName && (
          <i className={`ms-Icon ms-Icon--${icons.pageEdit.iconName}`} />
        )}
      </div>
      <Text variant="large" className={emptyStructureClass.title}>
        No templates added yet.
      </Text>
      <Text variant="medium" className={emptyStructureClass.description}>
        Use the{" "}
        <span 
          className={emptyStructureClass.link}
          onClick={handleAddTemplateClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleAddTemplateClick();
            }
          }}
          role="button"
          tabIndex={0}
        >
          Add template
        </span>
        {" "}button to find and add 
        the template this policy will be applicable for
      </Text>
    </div>
  );
}

export default PolicyEditEmptyStructure;